module.exports = __webpack_public_path__ + "static/media/qb.a07fc290.png";